// * Hack to avoid widget collapse on change of placement in editor.
//    * Details: https://github.com/wix-private/wix-ai-assistant-bot/issues/162
//    * Originally made by Tkachenko in controller.ts
import { useEffect } from 'react';

import { useEnvironment } from '@wix/yoshi-flow-editor';

import { expandWidget } from '@/features';
import { useAppDispatch } from '@/store';

import settingsParams from 'AiAssistantWidget/settingsParams';
import { useWidgetSettings } from 'AiAssistantWidget/Widget/contexts';

export function useForcedExpandInEditor() {
  const dispatch = useAppDispatch();
  const { isEditor } = useEnvironment();
  const settings = useWidgetSettings();

  useEffect(() => {
    if (!isEditor) {
      return;
    }

    const rawForceExpandedState = Number(
      settings.get(settingsParams.forceExpandedStateInEditor, 'primary') ?? 0,
    );
    const SETTINGS_forceExpandedStateInEditor = Number.isFinite(
      rawForceExpandedState,
    )
      ? rawForceExpandedState
      : 0;

    let SESSION_reactedOnForceExpand = 0;
    try {
      SESSION_reactedOnForceExpand = Number(
        sessionStorage.getItem('reactedOnForceExpand') ?? 0,
      );
      if (!Number.isFinite(SESSION_reactedOnForceExpand)) {
        SESSION_reactedOnForceExpand = 0;
      }
    } catch {}

    if (SETTINGS_forceExpandedStateInEditor === 0) {
      try {
        sessionStorage.removeItem('reactedOnForceExpand');
      } catch {}
    }

    if (SETTINGS_forceExpandedStateInEditor !== SESSION_reactedOnForceExpand) {
      try {
        sessionStorage.setItem(
          'reactedOnForceExpand',
          String(SETTINGS_forceExpandedStateInEditor),
        );
      } catch {}

      dispatch(expandWidget());
    }
  }, [
    dispatch,
    isEditor,
    // Derive a stable primitive for deps array
    settings?.get?.(settingsParams.forceExpandedStateInEditor, 'primary'),
  ]);
}
